import * as yup from 'yup';

export const initialValues = {
  sku: '',
  washHub: '',
  quantity: '',
};

export const validationSchema = yup.object().shape({
  sku: yup.string().required('SKU is required'),
  washHub: yup.string(),
  quantity: yup
    .number()
    .typeError('Quantity is required')
    .integer('Quantity must be a whole number')
    .min(1, 'Quantity must be at least 1')
    // Each unit is its own record; the API refuses more than 1000 at once.
    .max(1000, 'Add at most 1000 at a time')
    .required('Quantity is required'),
});
